import React, { FC } from 'react';
import { format } from 'date-fns';

interface BookingDateCellProps {
  day: number;
  date: Date;
  price: number | null;
  isDisabled: boolean;
  isLoading: boolean;
}

const BookingRates: FC<BookingDateCellProps> = ({ day, date, price, isDisabled, isLoading }) => {
  return (
    <div className="flex flex-col items-center justify-center py-1 px-2 space-y-1 min-w-[50px]">
      {/* Day number */}
      <span className="text-sm font-medium">{day}</span>

      {/* Price or placeholder */}
      {isLoading ? (
        <span className="text-xs font-light">…</span>
      ) : !isDisabled && price != null ? (
        <span className="text-xs font-semibold text-green-600 leading-none">
          ${price}
        </span>
      ) : (
        <span className="text-xs font-semibold text-gray-300 leading-none">- -</span>
      )}
    </div>
  );
};

export default BookingRates;
